import * as HTTP from './http';

export const GetTracking = async (token = '', order, status) => {
    let endpoint = `parts/tracking/${order}/${encodeURIComponent(status)}`;

    try{
        var result = await HTTP.GET(endpoint, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: parts.traking\n${e}`);
        return undefined;
    }

    return result;
}

export const UpdateStatus = async (token, body) => {
    let endpoint = `parts/update/status`;

    try{
        var result = await HTTP.POST(endpoint, body, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: parts.update.status\n${e}`);
        return undefined;
    }

    return result;
}

export const GetDetailFullByOrder = async (order) => {
    let endpoint = `parts/detail/full/order/${order}`;

    try{
        var result = await HTTP.GET(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: parts.GetDetailFullByOrder\n${e}`);
        return undefined;
    }

    return result;
}

export const Reprint = async (body, token) => {
    let endpoint = `parts/reprint`;

    try{
        var result = await HTTP.PUT(endpoint, body, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: parts.Reprint\n${e}`);
        return undefined;
    }

    return result;
}

export const Restart = async (body, token) => {
    let endpoint = `parts/restart`;

    try{
        var result = await HTTP.PUT(endpoint, body, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: parts.Restart\n${e}`);
        return undefined;
    }

    return result;
}

export const UpdateSvg = async (order, token) => {
    let endpoint = `parts/update/svg/${Number(order)}`;

    try{
        var result = await HTTP.GET(endpoint, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: parts.UpdateSvg\n${e}`);
        return undefined;
    }

    return result;
}

export const DownloadGcodeFile = async (part, kind, token) => {
    const endpoint = `parts/${Number(part)}/gcode-file/${encodeURIComponent(kind)}`;

    try{
        return await HTTP.GET_CSV(endpoint, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: parts.DownloadGcodeFile\n${e}`);
        return undefined;
    }
}
